module.exports = __webpack_public_path__ + "img/danye7.e13192c8.jpg";